import { useState } from "react";
import { useTitle } from "../../hooks/useTitle";
import { UploadSearchSuggestionsForm } from "../../patterns/UploadSearchSuggestionsForm";

export const SearchSuggestionsAdmin = () => {
  useTitle("Search Suggestions Admin | Compass");

  const [message, setMessage] = useState<string>("");

  return (
    <div style={{ padding: "1rem" }}>
      <UploadSearchSuggestionsForm
        onSubmit={(msg: string) => {
          setMessage(msg);
        }}
      />
      {message && (
        <div
          style={{
            marginTop: "1rem",
            padding: "1rem",
            backgroundColor: "#d4edda",
            color: "#155724",
            borderRadius: "0.25rem",
          }}
        >
          {message}
        </div>
      )}
    </div>
  );
};
